import React from "react";
import { AppName } from "../../config";

const Footer = () => {

  const currentYear = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="container-fluid d-flex justify-content-between">
        <nav className="pull-left">
          <ul className="nav">
            <li className="nav-item">
              <a className="nav-link" href="#">
                Help
              </a>
            </li>
            <li className="nav-item">
              <a className="nav-link" href="#">
                Licenses
              </a>
            </li>
          </ul>
        </nav>
        <div className="copyright">
          © Copyright {currentYear}. {AppName.appName}, LLC. All Rights Reserved
        </div>
        <div>Design and Developed by Developers Street</div>
      </div>
    </footer>
  );
};

export default Footer;
